/* @flow strict */

import * as React from 'react';
import { DateTimePicker, DatePicker } from 'react-tempusdominus-bootstrap';
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import './custom.scss';

type PropsType = {
  date?: string | {},
  className?: string,
  cb?: () => void,
  dateFormat?: string,
  time?: {},
  noIcon?: boolean,
  showTimeSelect?: boolean
};

const _DateTimePicker = (props: PropsType): React.Element => {
  const [startDate, setStartDate] = React.useState(
    props.date && props.date !== 'now' ? new Date(props.date) : new Date()
  );
  const [defaultDate, setDefaultDate] = React.useState(null);

  const handleChange = (date: string): any => {
    const offSetted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

    if (props.cb) {
      props.cb(moment(date).format('YYYY-MM-DDTHH:mm:ss[Z]'));
    }
    return setStartDate(offSetted);
  };

  React.useEffect(() => {
    setDefaultDate(new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000));
  }, [startDate]);


  if (!defaultDate) return null;
  const { showTimeSelect, noIcon } = props;

  return (
    <div className='dateTimePicker-container'>
      {
        showTimeSelect ?
          <DateTimePicker
            className={`${props.className} ${noIcon ? 'noIcon' : ''}` || ''}
            // format={props.dateFormat || 'MM/DD/YYYY'}
            date={defaultDate}
            noIcon={noIcon}
            onChange={(e: any): any => {
              handleChange(e.date.toDate());
            }}
          /> :
          <DatePicker
            className={`${props.className} ${noIcon ? 'noIcon' : ''}` || ''}
            // format={props.dateFormat || 'MM/DD/YYYY'}
            date={defaultDate}
            noIcon={noIcon}
            onChange={(e: any): any => {
              handleChange(e.date.toDate());
            }}
          />
      }
    </div>
  );
};

export default _DateTimePicker;
